import { Elements } from '@stripe/react-stripe-js';

import { stripe as stripePromise } from '../../../../stripe';
import { PaymentForm } from './PaymentForm';
import { PaymentIntentDetails } from '../../../../Checkout/views/PaymentGateway';

type CheckoutClientProps = {
	amount: number;
	giftCardNumber: number;	
	onClose?: () => void;
	onBack?: () => void;
	paymentDetails: PaymentIntentDetails
};

export const CheckoutClient: React.FC<CheckoutClientProps> = ({
	amount,
	giftCardNumber,
	paymentDetails,
	onClose,
	onBack
}) => {
	return (
		<Elements
			options={{
				clientSecret: paymentDetails.clientSecret,
				appearance: {
					variables: {
						iconColor: '#f47920',
						colorPrimary: '#f47920'
					}
				}
			}}
			stripe={stripePromise}
		>
			<PaymentForm
				balanceToAdd={amount}
				giftCardNumber={giftCardNumber}
				paymentDetails={paymentDetails}
				onClose={onClose}
				onBack={onBack}
			/>
		</Elements>
	);
};
